module.exports = __webpack_public_path__ + "download/img/jkb_image.3d4131e7.png";